import FirebaseContext, { withFirebase } from "./context"
import Firebase from "./fire"

export default Firebase

export { FirebaseContext, withFirebase }
